export const SET_INPUT_FOCUS = "SET_INPUT_FOCUS";
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
export const SET_SEARCH_SUGGESTIONS = "SET_SEARCH_SUGGESTIONS";
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
export const SET_FILTER_TYPE = "SET_FILTER_TYPE";